import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Grid,
  Button,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  TableContainer,
  Pagination,
  Stack,
  Paper,
} from "@mui/material";
import { format } from "date-fns";
import ScaleLoader from "react-spinners/ScaleLoader";
import useStyles from "../../assets/styles/SupMangComp.style";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import noTableData from "../../assets/images/noTableData.svg";
import API from "../../../src/utils/Axios.utils";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import useDebounce from "../../utils/useDebounce";
import CustomModel from "../../utils/CustomModel";
import { Notification } from "../../utils/Notification";
import SupplierDetails from "./SupplierDetails";
import Visibility from "@mui/icons-material/Visibility";

const SupMangComp = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [supplierData, setSupplierData] = useState([]);
  const [update, setUpdate] = useState(0);

  // Snackbar
  const [alert, setAlert] = React.useState(false);
  const [alertContent, setAlertContent] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  // Pagination
  // To do set total data count of api
  const [listCount, setListCount] = useState(0);
  const [page, setPage] = useState(1);

  const [open, setOpen] = React.useState(false);

  const ref = React.useRef(open);

  const handleDialog = () => {
    setOpen(!open);
  };

  const handleAlert = () => {
    setAlert(false);
  };

  const handlePageChange = (e, value) => {
    setPage(value);
  };

  const handleNavigate = () => {
    navigate("/suppliermanagement/addSupplier");
  };

  const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const debouncedQueryList = useDebounce(searchText, 500);

  const getSupplier = async () => {
    setShowLoader(true);
    let url = `/api/users/allsupplier?page=${page}&pageSize=10`;

    if (searchText !== "") {
      url += `&search=${debouncedQueryList}`;
    }

    try {
      const res = await API.get(url, config);
      setShowLoader(false);
      setSupplierData(res?.data?.supplier);
      setListCount(res?.data?.totalCount);
    } catch (error) {
      setShowLoader(false);
      setAlertContent(error?.response?.data?.message);
      setAlertType("error");
      setAlert(true);
    }
  };

  useEffect(() => {
    getSupplier();
  }, [page, debouncedQueryList, update]);
  const handleDownloadSupplierReport = async () => {
    try {
      setShowLoader(true);
      const token = JSON.parse(localStorage.getItem('userLoggedIn')).token;
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const response = await API.get('/api/job/supplier-report', {  // ✅ Supplier endpoint
        ...config,
        responseType: 'blob' // Important for binary Excel data
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `SupplierWise_Report_${format(new Date(), 'yyyy-MM-dd')}.xlsx`);  // ✅ Supplier filename
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      setAlertContent(error?.response?.data?.message || 'Failed to download supplier report');
      setAlertType('error');
      setAlert(true);
    }
  };
  return (
    <div style={{ marginTop: "20px" }}>
      <Grid
        container
        xs={12}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          variant="contained"
          aria-haspopup="true"
          onClick={handleNavigate}
          style={{ background: "#2777AA", width: "214px" }}
        >
          + Add Supplier
        </Button>
      </Grid>
      <Grid container xs={12} style={{ marginTop: "2%" }}>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <span className={classes.headingText}>Supplier</span>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <TextField
            name="search"
            label="Search by Supplier Name"
            variant="outlined"
            size="small"
            style={{ backgroundColor: "#fff", width: 230 }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: searchText !== "" && (
                <InputAdornment position="end">
                  <IconButton>
                    <CloseIcon onClick={() => setSearchText("")} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        {/* <Grid item xs={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <span className={classes.headingText}>Suppliers</span>
        </Grid>
        <Grid item xs={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
          <TextField
            name="search"
            label="Search by Supplier Name"
            variant="outlined"
            size="small"
            style={{ backgroundColor: '#fff', width: '230px' }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: searchText ? (
                <InputAdornment position="end">
                  <IconButton onClick={() => setSearchText('')}>
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ) : null
            }}
          />
          <Button
            variant="contained"
            onClick={handleDownloadSupplierReport}
            disabled={showLoader}
            style={{
              background: 'success',  // ✅ Blue theme color (same as your tables)
              color: 'white',
              minWidth: '120px',
              height: '40px'
            }}
          >
            {showLoader ? 'Downloading...' : 'Download Report'}
          </Button>
        </Grid> */}
      </Grid>
      <Grid container xs={12} className={classes.tableGrid}>
        {showLoader ? (
          <div
            style={{
              display: "flex",
              height: 400,
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <ScaleLoader size={250} color={"#0576DC"} loading={showLoader} />
          </div>
        ) : supplierData.length === 0 ? (
          <div
            style={{
              height: 300,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img src={noTableData} width={60} alt="No Data" />
            <div
              style={{
                marginTop: 5,
                fontWeight: "500",
                fontSize: 25,
                fontFamily: "'Noto Sans', sans-serif",
              }}
            >
              There are no recent Suppliers to show.
            </div>
          </div>
        ) : (
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow className={classes.tableHeadRow}>
                  <TableCell className={classes.tableHeadCell}>
                    Supplier Code
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    Supplier Organization Name
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    Supplier Admin Name
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>Email</TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <>
                <TableBody className={classes.noHorizontalBorderTableRow}>
                  {supplierData.map((val) => {
                    return (
                      <TableRow>
                        <TableCell className={classes.tableBodyCell}>
                          {val.supplier_code}
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          {val.supplier_org_name}
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          {val.supplier_admin_name}
                        </TableCell>
                        <TableCell>{val.supplier_admin_email}</TableCell>
                        <TableCell>
                          <SupplierMoreMenu
                            navigate={navigate}
                            details={val}
                            setUpdate={setUpdate}
                            update={update}
                            setAlertContent={setAlertContent}
                            setAlertType={setAlertType}
                            setAlert={setAlert}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </>
            </Table>
            <Stack
              spacing={2}
              sx={{
                padding: 2,
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              <Pagination
                classes={{
                  root: classes.pagination,
                }}
                count={Math.ceil(listCount / 10)}
                page={page}
                onChange={handlePageChange}
                showFirstButton
                showLastButton
              />
            </Stack>
          </TableContainer>
        )}
      </Grid>
      <Notification
        message={alertContent}
        open={alert}
        severity={alertType}
        onClose={handleAlert}
      />
    </div>
  );
};

export default SupMangComp;

function SupplierMoreMenu({
  details,
  navigate,
  update,
  setUpdate,
  setAlertContent,
  setAlertType,
  setAlert,
}) {
  const handleDialogdel = () => {
    setDelOpen(!delOpen);
  };

  const [delOpen, setDelOpen] = React.useState(false);

  const refDel = React.useRef(delOpen);

  const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const handleSupplierDelete = () => {
    API.delete(`/api/users/supplier/${details.supplier_id}`, config)
      .then((res) => {
        handleDialogdel();
        setUpdate(update + 1);
        setAlertContent(res?.data?.message);
        setAlertType("success");
        setAlert(true);
      })
      .catch((error) => {
        setAlertContent(error?.response?.data?.message);
        setAlertType("error");
        setAlert(true);
      });
  };
  return (
    <>
      <IconButton
        onClick={() => {
          navigate("/suppliermanagement/ViewSupplier", {
            state: { supplierDetails: details },
          });
        }}
      >
        <Visibility sx={{ color: "#2777AA" }} />
      </IconButton>

      <IconButton
        onClick={() => {
          navigate("/suppliermanagement/editSupplier", {
            state: { supplierDetails: details },
          });
        }}
      >
        <EditIcon sx={{ color: "#2777AA" }} />
      </IconButton>

      <CustomModel
        handleDialog={handleDialogdel}
        open={delOpen}
        title="Delete Job"
      >
        <div
          style={{
            textAlign: "center",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontSize: "24px",
          }}
        >
          Do you want to delete the Supplier?
        </div>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "1em",
              gap: "10px",
            }}
          >
            <Button
              variant="contained"
              onClick={() => handleSupplierDelete(details?.job_id)}
              style={{ background: "#2777AA" }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={() => handleDialogdel()}
              style={{ background: "#2777AA" }}
            >
              NO
            </Button>
          </div>
        </Grid>
      </CustomModel>

      <IconButton
        ref={refDel}
        onClick={() => {
          setDelOpen(true);
        }}
      >
        <DeleteIcon sx={{ color: "red" }} />
      </IconButton>
    </>
  );
}
